import { ChangeEvent, FocusEvent, useState } from 'react';

/** Tracks focused phrase input and shows helper text while it contains text. */
export const usePhraseInputInfo = () => {
  const [activePhraseInputIndex, setActivePhraseInputIndex] = useState<
    number | null
  >(null);
  const [phraseInputValue, setPhraseInputValue] = useState('');

  const handlePhraseInputFocus = (
    event: FocusEvent<HTMLInputElement | HTMLTextAreaElement>,
    index: number
  ) => {
    setActivePhraseInputIndex(index);
    setPhraseInputValue(event.currentTarget.value);
  };

  const handlePhraseInputBlur = () => setActivePhraseInputIndex(null);

  const handlePhraseInputChange = (
    event: ChangeEvent<HTMLInputElement | HTMLTextAreaElement>,
    index: number
  ) => {
    setActivePhraseInputIndex(index);
    setPhraseInputValue(event.target.value);
  };

  return {
    handlePhraseInputFocus,
    handlePhraseInputBlur,
    handlePhraseInputChange,
    showPhraseInputInfo:
      activePhraseInputIndex !== null && phraseInputValue.trim() !== ''
  };
};
